export var MAX_LENGTH_FOR_COUNTRY = {
  US: 14,
  CA: 14,
  AU: 14
};
export var AVAILABLE_COUNTRIES = [{
  name: '+1 (US)',
  value: 'US'
}, {
  name: '+1 (CA)',
  value: 'CA'
}, {
  name: '+61 (AU)',
  value: 'AU'
}];